import React, { useEffect, useRef } from 'react'

const ScrollToBottom = () => {
    const elementRef = useRef()
    useEffect(() => elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }))
    return <div ref={elementRef} />
}

export default ScrollToBottom
